import { createFileRoute } from '@tanstack/react-router';
import { LeadDetail } from '../features/leads/LeadDetail';

export const Route = createFileRoute('/leads/$leadId')({
  component: () => {
    const { leadId } = Route.useParams();
    return <LeadDetail leadId={leadId} />;
  },
});
